import React from 'react'
import {
    Button,
    Spinner,
    Modal,
    Form
} from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";

const UnPublishModel = ({ isOpen, onClose, onConfirm, title, loader }) => {
    return (
        <>
            <Modal
                size="md"
                show={isOpen}
                onHide={onClose}
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Unpublish</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to unpublish this {title}?
                </Modal.Body>
                <Modal.Footer>
                    {loader ? (
                        <Spinner animation="border" variant="primary" />
                    ) : (
                        <>
                            <Button className='primaryBtn me-3' onClick={() => onConfirm(false)} >
                                <Icon.HandThumbsUp className='me-1' />Yes</Button>
                            <Button className='secondaryBtn' onClick={onClose} >
                                <Icon.HandThumbsDown className='me-1' />No</Button>
                        </>
                    )}
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default UnPublishModel